<template>
  <section class="section pt-1 bg-white">
    <div class="container">
      <h1 class="mb-4">{{ $t("help.platform.policy.text") }}</h1>

      <div role="tablist">
        <b-card no-body class=" shadow-none mb-3">
          <b-card-body>
            <p class="mb-3">
              {{ $t("help.platform.policy.line-1") }}
            </p>

            <p class="mb-3">{{ $t("help.platform.policy.line-2") }}</p>
            <p class="mb-3">{{ $t("help.platform.policy.line-3") }}</p>
          </b-card-body>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1' ? 'founded' : ''" v-b-toggle.col1>
              <div>{{ $t("help.platform.policy.card.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col1" :visible="col == 'col1'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-0">
                {{ $t("help.platform.policy.card.line-1") }}
              </p>

              <img src="@/assets/images/help/policy-card.png" class="image" />

              <p class="mt-3 mb-3">
                {{ $t("help.platform.policy.card.line-2") }}
              </p>

              <p class="mt-3 mb-3" v-html="$t('help.platform.policy.card.line-3')"></p>
              <p class="mt-3 mb-3" v-html="$t('help.platform.policy.card.line-4')"></p>
              <p class="mt-3 mb-3" v-html="$t('help.platform.policy.card.line-5')"></p>
              <p class="mt-3 mb-3" v-html="$t('help.platform.policy.card.line-6')"></p>
              <p class="mt-3 mb-3" v-html="$t('help.platform.policy.card.line-7')"></p>
              <p class="mt-3 mb-3" v-html="$t('help.platform.policy.card.line-8')"></p>
              <p class="mt-3 mb-3" v-html="$t('help.platform.policy.card.line-9')"></p>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col2' ? 'founded' : ''" v-b-toggle.col2>
              <div>{{ $t("help.platform.policy.assessment.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col2" :visible="col == 'col2'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.policy.assessment.line-1") }}
              </p>

              <!-- <h5 class="mt-5">{{$t("help.organization.create.sample-screen")}}</h5> -->
              <img src="@/assets/images/help/policy-status.png" class="image" />

              <p class="mt-3">{{ $t("help.platform.policy.assessment.line-2") }}</p>
              <p class="mt-3">{{ $t("help.platform.policy.assessment.line-3") }}</p>
              <p class="mt-3 mb-3">{{ $t("help.platform.policy.assessment.line-4") }}</p>
              <img src="@/assets/images/help/policy-detail.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.policy.assessment.line-5") }}</p>
              <img src="@/assets/images/help/policy-compliance-status.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.policy.assessment.line-6") }}</p>
              <p class="mt-3 mb-3" v-html="$t('help.platform.policy.card.line-7')"></p>

              <ul>
                <li>
                  <p class="mb-3">
                    {{ $t("help.platform.policy.assessment.line-8") }}
                  </p>
                </li>
                <li>
                  <p class="mb-3">
                    {{ $t("help.platform.policy.assessment.line-9") }}
                  </p>
                </li>
                <li>
                  <p class="mb-3">
                    {{ $t("help.platform.policy.assessment.line-10") }}
                  </p>
                </li>
                <li>
                  <p class="mb-3">
                    {{ $t("help.platform.policy.assessment.line-11") }}
                  </p>
                </li>
                <li>
                  <p class="mb-3">
                    {{ $t("help.platform.policy.assessment.line-12") }}
                  </p>
                </li>
              </ul>

              <p class="mt-3 mb-3" v-html="$t('help.platform.policy.assessment.line-13')"></p>
              <p class="mt-3 mb-3" v-html="$t('help.platform.policy.assessment.line-14')"></p>

              <ul>
                <li>
                  <p class="mb-3">
                    {{ $t("help.platform.policy.assessment.line-15") }}
                  </p>
                </li>
                <li>
                  <p class="mb-3">
                    {{ $t("help.platform.policy.assessment.line-16") }}
                  </p>
                </li>
              </ul>

              <p class="mt-3 mb-3" v-html="$t('help.platform.policy.assessment.line-17')"></p>
              <img src="@/assets/images/help/policy-action-plan.png" class="image" />
              <p class="mt-3 mb-3" v-html="$t('help.platform.policy.assessment.line-18')"></p>
              <p class="mt-3 mb-3" v-html="$t('help.platform.policy.assessment.line-19')"></p>
              <p class="mb-3">
                {{ $t("help.platform.policy.assessment.line-20") }}
              </p>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col3' ? 'founded' : ''" v-b-toggle.col3>
              <div>{{ $t("help.platform.policy.in-progress.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col3" :visible="col == 'col3'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.policy.in-progress.line-1") }}
              </p>
              <img src="@/assets/images/help/in-progress-policies.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.policy.in-progress.line-2") }}</p>
              <img src="@/assets/images/help/action-plan-task.png" class="image" />

              <p class="mt-3 mb-3">{{ $t("help.platform.policy.in-progress.line-3") }}</p>
              <p class="mt-3 mb-3">{{ $t("help.platform.policy.in-progress.line-4") }}</p>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col4' ? 'founded' : ''" v-b-toggle.col4>
              <div>{{ $t("help.platform.policy.periodical.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col4" :visible="col == 'col4'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.policy.periodical.line-1") }}
              </p>
              <img src="@/assets/images/help/periodical-policies.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.policy.periodical.line-2") }}</p>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col5' ? 'founded' : ''" v-b-toggle.col5>
              <div>{{ $t("help.platform.policy.completed.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col5" :visible="col == 'col5'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.policy.completed.line-1") }}
              </p>
              <img src="@/assets/images/help/completed-policies.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.policy.completed.line-2") }}</p>

              <img src="@/assets/images/help/completed-action-plan.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.policy.completed.line-3") }}</p>
              <p class="mt-3 mb-3">{{ $t("help.platform.policy.completed.line-4") }}</p>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col6' ? 'founded' : ''" v-b-toggle.col6>
              <div>{{ $t("help.platform.policy.scope.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col6" :visible="col == 'col6'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.policy.scope.line-1") }}
              </p>
              <img src="@/assets/images/help/out-of-scope-policies.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.policy.scope.line-2") }}</p>

              <img src="@/assets/images/help/policy-scope-button.png" class="image" />
              <p class="mt-3 mb-3">{{ $t("help.platform.policy.scope.line-3") }}</p>

              <img src="@/assets/images/help/policy-scope-history.png" class="image" />
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col7' ? 'founded' : ''" v-b-toggle.col7>
              <div>{{ $t("help.platform.policy.new.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col7" :visible="col == 'col7'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.policy.new.line-1") }}
              </p>
              <img src="@/assets/images/help/new-policy.png" class="image" />

              <p class="mt-3 mb-3" v-html="$t('help.platform.policy.new.line-2')"></p>
              <p class="mb-3">
                {{ $t("help.platform.policy.new.line-3") }}
              </p>
              <p class="mb-3">
                {{ $t("help.platform.policy.new.line-4") }}
              </p>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      col: "col1",
    };
  },
  mounted() {
    setTimeout(() => {
      const { col } = this.$route.query;
      this.col = col;
      window.scrollTo({ top: 700, behavior: "smooth" });
    }, 500);
  },
};
</script>

<style scoped>
.founded {
  background: yellow !important;
}
.image {
  display: block;
  max-width: 100%;
}
</style>
